export default "__VITE_ASSET__CN82J_nW__"